import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class CatalogService extends BaseService {

    static url = "catalog";
    static apis = {
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("catalog");
    }


}

export default CatalogService;